import { useEffect, useRef, useState } from "react";
import { colors } from "../../Styles";

const INACTIVITY_TIMEOUT = 3000;

export function Arrow({rotate = 0, transparency = 1, size = "20px", fillColor = colors.greyLightTertiary, transition = 0, animate = false}) {
  // const [lastActivityTime, setLastActivityTime] = useState(Date.now());
  // const [shouldAnimate, setShouldAnimate] = useState(false);
  // const idleTimerRef = useRef<NodeJS.Timeout | undefined>(undefined);

  // const pulseAnimation = `
  //   @keyframes pulse {
  //     0% { opacity: 0; }
  //     20% { opacity: 1; }
  //     40% { opacity: 0; }
  //     60% { opacity: 1; }
  //     80% { opacity: 0; }
  //     100% { opacity: 0; }
  //   }
  // `;

  // const recordActivity = () => {
  //   setLastActivityTime(Date.now());
  //   setShouldAnimate(false); // Skjul pilene med det samme ved aktivitet
  //   clearTimeout(idleTimerRef.current); // Nulstil timeren med det samme
  // };

  // Sæt event listeners op for brugeraktivitet (gælder for hele vinduet)
  // useEffect(() => {
  //   window.addEventListener('mousemove', recordActivity);
  //   window.addEventListener('keydown', recordActivity);
  //   window.addEventListener('click', recordActivity);
  //   window.addEventListener('scroll', recordActivity);
  //   // Tilføj også en listener for touch events for mobil
  //   window.addEventListener('touchstart', recordActivity);
  //   window.addEventListener('touchmove', recordActivity);

  //   return () => {
  //     window.removeEventListener('mousemove', recordActivity);
  //     window.removeEventListener('keydown', recordActivity);
  //     window.removeEventListener('click', recordActivity);
  //     window.removeEventListener('scroll', recordActivity);
  //     window.removeEventListener('touchstart', recordActivity);
  //     window.removeEventListener('touchmove', recordActivity);
  //   };
  // }, []); // Tomt dependency array sikrer, at denne effekt kun kører én gang ved mount/unmount

  // // Effekt til at styre inaktivitetstimeren og animationen
  // useEffect(() => {
  //   if (animate) { // Kun start timer, hvis 'animate' prop er sand
  //     clearTimeout(idleTimerRef.current); // Ryd enhver eksisterende timer

  //     idleTimerRef.current = setTimeout(() => {
  //       if (Date.now() - lastActivityTime >= INACTIVITY_TIMEOUT) {
  //         setShouldAnimate(true); // Start animationen efter inaktivitet
  //       }
  //     }, INACTIVITY_TIMEOUT);
  //   } else {
  //     clearTimeout(idleTimerRef.current); // Ryd timeren, hvis 'animate' er falsk
  //     setShouldAnimate(false); // Stop animationen
  //   }

  //   // Oprydningsfunktion for effekten
  //   return () => {
  //     clearTimeout(idleTimerRef.current);
  //   };
  // }, [animate, lastActivityTime]); // Kør igen, når 'animate' eller 'lastActivityTime' ændres

  // // Bestem om animation skal anvendes, og om elementet skal være synligt
  // const animationStyle = animate && shouldAnimate ? {
  //   animation: `pulse ${transition}s infinite`
  // } : {
  //   opacity: 0, // Gør elementet usynligt, når det ikke skal animeres
  //   transition: `${transition}s ease-in-out` // Bevar transition for glat fade ud
  // };
  
  return ( <>
    {/* {animate && (
      <style>
        {pulseAnimation}
      </style>
    )} */}
    <svg style={{transform: `rotate(${rotate}deg)`, transition: `${transition}s ease-in-out`}} opacity={transparency} rotate={rotate} height={size} width={size} fill={fillColor} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 283.46 283.46">  
      <g transform="matrix(1,0,0,1,-5.615,6.9)">
        <path d="M274.9,134.83L158.85,67.82L158.85,106.83L19.79,106.83L19.79,162.83L158.85,162.83L158.85,201.84L274.9,134.83Z"/>
      </g>
    </svg>
  </> );
}